export default __webpack_public_path__ + "static/media/776.a5ede2ba.png";